import { cn } from "@/utils/cn";
import { memo } from "react";

import {
  getMarkerPositionPercent,
  type ProgressBreakpoints,
  type SegmentMaxPercentages,
} from "../calorie-progress-bar/progress-bar-track";
export type {
  ProgressBreakpoints,
  SegmentMaxPercentages,
} from "../calorie-progress-bar/progress-bar-track";

interface ProgressBarTrackProps {
  breakpoints: ProgressBreakpoints;
  value: number;
  segmentMaxPercentages?: SegmentMaxPercentages;
}

const DEFAULT_SEGMENT_MAX_PERCENTAGES: SegmentMaxPercentages = [30, 50, 70, 100];

export const ProgressBarTrack = memo(function ProgressBarTrack({
  breakpoints,
  value,
  segmentMaxPercentages = DEFAULT_SEGMENT_MAX_PERCENTAGES,
}: ProgressBarTrackProps) {
  const markerPosition = getMarkerPositionPercent(breakpoints, value, segmentMaxPercentages);

  return (
    <div className="relative mt-2 h-7">
      <div
        className={cn(
          "absolute inset-0 rounded-[30px]",
          "bg-[linear-gradient(180deg,color-mix(in_srgb,var(--color-gray-100)_8%,transparent)_-46.25%,color-mix(in_srgb,var(--color-gray-50)_8%,transparent)_100%)]",
          "shadow-[inset_0_4px_6px_0_rgba(0,0,0,0.06)]",
        )}
      />
      <div className={cn("absolute inset-[1px] overflow-hidden rounded-[30px]")}>
        <div
          className={cn(
            "absolute top-1/2 left-1/2 h-[133px] w-[133px] -translate-x-1/2 -translate-y-1/2 rounded-full",
            "bg-[linear-gradient(90deg,transparent_0%,var(--color-check-green)_50%,transparent_100%)]",
          )}
        />
      </div>
      <div className="absolute inset-0 rounded-[30px] border border-[color-mix(in_srgb,var(--color-violet-950)_40%,transparent)]" />
      <div className="absolute inset-y-0 right-1 left-1">
        <div
          className="absolute top-1/2 h-[22px] w-1 -translate-x-1/2 -translate-y-1/2 bg-[linear-gradient(180deg,var(--color-white)_0%,var(--color-gray-300)_343.75%)] shadow-[0_2px_6px_0_rgba(0,0,0,0.25)]"
          style={{ left: `${markerPosition}%` }}
        />
      </div>
    </div>
  );
});
